import * as React from 'react';
import ActionItem from './ActionItem';
import ActionSubmenu, {AnimatedActionSubmenu} from './ActionSubmenu';

// usage example:
// <ActionsMenu open>
// 	<ActionItem title="delete" onActionClick={this.deleteField} icon={<img src="../images/bin.jpg" />}>
// 		<ActionSubmenu>
// 			<ActionItem title="sub action" onClick={this.subActionClick}/>
// 		</ActionSubmenu>
// 	</ActionItem>
// 	<ActionItem title="close" onActionClick={this.closeMenu} />
// 	<p>...</p>
// </ActionsMenu>

interface ActionsMenuProps {
    open: boolean;
    children: React.ReactNode;
    className?: string;
}

export default class ActionsMenu extends React.Component<ActionsMenuProps, null> {
    render() {
        const {open, children, className} = this.props;
        return open ? (
            <div className={'field-actions ' + className}>
                {/* TODO: remove this extra div and fix style accordingly */}
                <div className="actions-wrapper">{children}</div>
            </div>
        ) : null;
    }
}

export {ActionItem, ActionSubmenu, AnimatedActionSubmenu};
